import {
  CloseRoundedIcon,
  Flex,
  IconButton,
  styled,
  Text,
  FormTimeInput,
  Box,
} from '@shared/components';
import { formatTimeToThaiUnits } from '@shared/utils';

const Wrapper = styled(Flex)(({ theme }) => ({
  borderRadius: theme.shape.rounded(1.5),
  padding: theme.spacing(4),
  gap: theme.spacing(6),
  border: '1px solid',
  borderColor: theme.palette.grey[300],
  backgroundColor: theme.palette.grey[50],
  position: 'relative',
}));

export interface SessionInputCardProps {
  order: number;
  duration: {
    hours: number;
    minutes: number;
  };
  inputName: {
    start: string;
    end: string;
  };
  errorMessage?: string;
  onClose?: () => void;
}

export default function SessionInputCard(props: Readonly<SessionInputCardProps>) {
  const {
    order,
    duration: { hours, minutes },
    inputName: { start, end },
    errorMessage,
    onClose,
  } = props;

  return (
    <Wrapper>
      <Text variant='body1Semibold'>ช่วงที่ {order}</Text>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(4),
          flex: 1,
        })}
      >
        <Flex
          sx={(theme) => ({
            alignItems: 'flex-start',
            gap: theme.spacing(2),
            maxWidth: '440px',
          })}
        >
          <FormTimeInput label='เวลาเริ่มต้น' required name={start} />
          <Text
            sx={(theme) => ({
              margin: theme.spacing(8.5, 0, 2.5, 0),
              flexShrink: 0,
            })}
          >
            ถึง
          </Text>
          <FormTimeInput label='เวลาสิ้นสุด' required name={end} />
        </Flex>
        <Box>
          <Text>ระยะเวลา: {formatTimeToThaiUnits({ hours, minutes })}</Text>
          {errorMessage ? (
            <Text
              variant='body2'
              sx={(theme) => ({
                color: theme.palette.error.main,
              })}
            >
              {errorMessage}
            </Text>
          ) : null}
        </Box>
      </Flex>
      {onClose ? (
        <IconButton
          onClick={onClose}
          type='button'
          sx={(theme) => ({
            position: 'absolute',
            padding: theme.spacing(1),
            margin: theme.spacing(3),
            right: 0,
            top: 0,
          })}
        >
          <CloseRoundedIcon />
        </IconButton>
      ) : null}
    </Wrapper>
  );
}
